/* START_MODULE_CONTRACT
 * PURPOSE: Шаг 2 регистрации: ввод и проверка кода подтверждения email.
 * SCOPE: React-компонент формы в стиле auth-страниц.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-AUTH, M-REGISTRATION
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * RegisterStepCode - шаг ввода кода подтверждения.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Кастомная форма в стиле auth-страниц вместо MUI.
 * END_CHANGE_SUMMARY
 */

import { useState } from 'react';
import { registerValidate } from '../../api/authApi';

/* START_METHOD_RegisterStepCode */
/* START_CONTRACT: RegisterStepCode
 * PURPOSE: Шаг 2 регистрации: ввод и проверка кода подтверждения email.
 * INPUTS: { email: string, onNext: ()=>void }.
 * OUTPUTS: { JSX.Element - форма }.
 * SIDE_EFFECTS: HTTP registerValidate; переход к следующему шагу.
 * LINKS: M-FE-AUTH, M-REGISTRATION
 * END_CONTRACT: RegisterStepCode
 */
export default function RegisterStepCode({ email, onNext }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  /* START_METHOD_handleSubmit */
  /* START_CONTRACT: handleSubmit
   * PURPOSE: Проверить код подтверждения; при успехе перейти к шагу пароля, иначе показать ошибку.
   * INPUTS: { e: SubmitEvent }.
   * OUTPUTS: { Promise<void> }.
   * SIDE_EFFECTS: HTTP registerValidate; onNext(); setError.
   * LINKS: M-REGISTRATION
   * END_CONTRACT: handleSubmit
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await registerValidate({ email, code });
      onNext();
    } catch (err) {
      setError(
        err.response?.data?.message || 'Неверный код подтверждения',
      );
    } finally {
      setLoading(false);
    }
  };
  /* END_METHOD_handleSubmit */

  return (
    <form onSubmit={handleSubmit} noValidate>
      {error ? (
        <div className="auth-page__alert" role="alert">
          {error}
        </div>
      ) : null}
      <div className="auth-page__notice" role="status">
        Код подтверждения отправлен на {email}
      </div>
      <div className="auth-page__field">
        <label className="auth-page__label" htmlFor="register-code">
          Код подтверждения
        </label>
        <input
          id="register-code"
          className="auth-page__input"
          type="text"
          name="code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          autoComplete="one-time-code"
          inputMode="numeric"
          autoFocus
          required
        />
      </div>
      <button
        type="submit"
        className="auth-page__submit"
        disabled={loading}
      >
        {loading ? 'Проверка…' : 'Подтвердить'}
      </button>
    </form>
  );
}
/* END_METHOD_RegisterStepCode */
